import {
  InView,
  useInView
} from "./chunk-W3VLFQND.esm.js";
import {
  useDrawer_default
} from "./chunk-NVQX4K25.esm.js";
import {
  useModal_default
} from "./chunk-GDRADE7B.esm.js";
import {
  usePopover_default
} from "./chunk-DFBK77CX.esm.js";
import "./chunk-EI7IFNUU.esm.js";
import {
  StockXGoldTheme_default
} from "./chunk-FJMLV5U2.esm.js";
import {
  theme_default
} from "./chunk-M7FL4KKM.esm.js";
import "./chunk-QSKJQZCB.esm.js";
import "./chunk-S2GVHNFV.esm.js";
import {
  NestedCheckbox_default
} from "./chunk-CHECJSBA.esm.js";
import "./chunk-BLZLM7OP.esm.js";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  AspectRatio,
  Badge,
  Box,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Center,
  ChakraProvider,
  Checkbox,
  CircularProgress,
  CircularProgressLabel,
  CloseButton,
  Code,
  Collapse,
  ColorModeProvider,
  ColorModeScript,
  Container,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Heading,
  Icon,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  InputRightAddon,
  InputRightElement,
  Link,
  List,
  ListIcon,
  ListItem,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Progress,
  Radio,
  RadioGroup,
  Select,
  SimpleGrid,
  SkeletonCircle,
  SkeletonText,
  Slide,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spacer,
  Stack,
  StackDivider,
  StatGroup,
  StatHelpText,
  StatLabel,
  StatNumber,
  Switch,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableCaption,
  Tabs,
  Tag,
  TagCloseButton,
  TagLabel,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tooltip,
  Tr,
  VStack,
  VisuallyHidden,
  chakra,
  cookieStorageManager,
  extendTheme,
  localStorageManager,
  shouldForwardProp,
  useBreakpoint,
  useCheckboxGroup,
  useClipboard,
  useColorMode,
  useColorModeValue,
  useDisclosure,
  useMediaQuery,
  useMultiStyleConfig,
  useOutsideClick,
  useRadio,
  useRadioGroup,
  useStyleConfig,
  useTheme,
  withDefaultColorScheme
} from "./chunk-BUIAK52M.esm.js";
import {
  useConstructor_default
} from "./chunk-CBIHE3IU.esm.js";
import {
  useDidUpdateEffect_default
} from "./chunk-5UOGR4QN.esm.js";
import {
  IconButton_default
} from "./chunk-H4KYG7HS.esm.js";
import {
  SxInput_default
} from "./chunk-7DOJX2PR.esm.js";
import {
  SxSelect_default
} from "./chunk-EE46CJAZ.esm.js";
import {
  SxTextarea_default
} from "./chunk-F5BR5MQS.esm.js";
import "./chunk-PHTCP5GI.esm.js";
import {
  PreloadAssets_default
} from "./chunk-JGPEML2V.esm.js";
import {
  Breadcrumb_default
} from "./chunk-6URTGP3H.esm.js";
import {
  colors_default
} from "./chunk-OZSFPHME.esm.js";
import "./chunk-4DAKPS37.esm.js";
import {
  DropdownItem_default
} from "./chunk-4SFT2XIX.esm.js";
import {
  FlyoutDropdown_default
} from "./chunk-HR47EIVB.esm.js";
import "./chunk-5L6DHCIQ.esm.js";
import "./chunk-BQXOZEXI.esm.js";
import {
  useDropdown_default
} from "./chunk-CG5QYGL5.esm.js";
import {
  CheckboxGroup_default
} from "./chunk-NEEMDUCO.esm.js";
import {
  Chip_default
} from "./chunk-JRMEB555.esm.js";
import {
  OrderedList_default
} from "./chunk-GR6WUTMA.esm.js";
import {
  Stat_default
} from "./chunk-HLT4HPAF.esm.js";
import {
  TagLeftIcon,
  TagRightIcon
} from "./chunk-VVCGWJL6.esm.js";
import {
  UnorderedList_default
} from "./chunk-D7MOWM2D.esm.js";
import {
  Loader_default
} from "./chunk-5VLNMCED.esm.js";
import {
  Skeleton_default
} from "./chunk-EGMR57C2.esm.js";
import "./chunk-Q6FVHJQC.esm.js";

// src/index.ts
export * from "@stockx/ui-images";
export * from "@stockx/ui-responsive";
export * from "@stockx/ui-modals";

// src/components/overlay/Modal/Modal.tsx
import { Modal as ChakraModal } from "@chakra-ui/react";
import { jsx } from "react/jsx-runtime";
var Modal = ({ children, ...rest }) => /* @__PURE__ */ jsx(ChakraModal, { motionPreset: "slideInBottom", ...rest, children });
var Modal_default = Modal;

// src/components/feedback/Toast/useToast.tsx
import { useToast as useChakraToast } from "@chakra-ui/react";

// src/components/feedback/Toast/Toast.tsx
import { WarningIcon } from "@chakra-ui/icons";
import { Text as Text3 } from "@chakra-ui/react";

// src/components/feedback/Toast/Toast.styles.tsx
import { Box as Box2, Flex as Flex2, Icon as Icon2, Text as Text2, chakra as chakra2 } from "@chakra-ui/react";
import { SmallCloseIcon } from "@chakra-ui/icons";
var Toast_styles_default = chakra2(Box2, {
  baseStyle: {
    m: 1,
    px: "7",
    py: "5",
    color: "neutral.white",
    bg: "neutral.black",
    borderRadius: "2px",
    position: "relative"
  }
});
var ToastContent = chakra2(Flex2, {
  baseStyle: {
    alignItems: "start"
  }
});
var ToastMessageContent = chakra2(Flex2, {
  baseStyle: {
    flexDirection: "column"
  }
});
var ToastIcon = chakra2(Icon2, {
  baseStyle: {
    marginRight: 2,
    marginTop: "3px",
    color: "neutral.white"
  }
});
var ToastAction = chakra2(Text2, {
  baseStyle: {
    marginTop: 2,
    cursor: "pointer",
    textDecoration: "underline",
    textAlign: "start"
  }
});
var CloseIcon = chakra2(SmallCloseIcon, {
  baseStyle: {
    position: "absolute",
    top: "4px",
    right: "4px",
    cursor: "pointer"
  }
});

// src/components/feedback/Toast/Toast.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var defaultIcon = WarningIcon;
var Toast = ({
  message,
  icon = defaultIcon,
  isCloseable,
  onClose,
  action
}) => /* @__PURE__ */ jsxs(Toast_styles_default, { children: [
  isCloseable && /* @__PURE__ */ jsx2(CloseIcon, { onClick: onClose }),
  /* @__PURE__ */ jsxs(ToastContent, { children: [
    /* @__PURE__ */ jsx2(ToastIcon, { as: icon }),
    /* @__PURE__ */ jsxs(ToastMessageContent, { children: [
      /* @__PURE__ */ jsx2(Text3, { children: message }),
      action && /* @__PURE__ */ jsx2(ToastAction, { onClick: action.handleClick, children: action.text })
    ] })
  ] })
] });
var Toast_default = Toast;

// src/components/feedback/Toast/useToast.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var DEFAULT_DURATION = 5e3;
var DEFAULT_POSTION = "bottom";
var useToast = () => {
  const defaultToast = useChakraToast();
  const toast = ({
    id,
    message,
    duration = DEFAULT_DURATION,
    position = DEFAULT_POSTION,
    isCloseable,
    icon,
    action
  }) => {
    if (!message) {
      return;
    }
    defaultToast({
      id,
      duration,
      position,
      render: ({ onClose }) => /* @__PURE__ */ jsx3(
        Toast_default,
        {
          message,
          icon,
          isCloseable,
          onClose,
          action
        }
      )
    });
  };
  const { close, closeAll, update, isActive } = defaultToast;
  toast.close = close;
  toast.closeAll = closeAll;
  toast.update = update;
  toast.isActive = isActive;
  return toast;
};
var useToast_default = useToast;

// src/components/forms/SearchInput/SearchInput.tsx
import React, { useRef } from "react";
import {
  Box as Box3,
  Input as Input2,
  InputGroup as InputGroup2,
  InputLeftElement as InputLeftElement2,
  InputRightElement as InputRightElement2,
  CloseButton as CloseButton2
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { jsx as jsx4, jsxs as jsxs2 } from "react/jsx-runtime";
var SearchInput = ({ callback, inputRightAddon, ...props }) => {
  const input = useRef(null);
  const addon = useRef(null);
  const [showCloseButton, setShowCloseButton] = React.useState(false);
  const handleToggleCloseButton = () => {
    if (input.current && input.current.value) {
      return setShowCloseButton(true);
    }
  };
  const handleClearSearch = () => {
    if (input.current && input.current.value) {
      input.current.value = "";
    }
    setShowCloseButton(false);
    if (callback) {
      callback();
    }
  };
  const handleCloseButtonPosition = () => {
    const addonValue = addon.current;
    let adjustedForAddon = "";
    if (addonValue) {
      adjustedForAddon = addonValue.clientWidth + 16;
    }
    return adjustedForAddon;
  };
  const closeButtonPosition = handleCloseButtonPosition();
  return /* @__PURE__ */ jsxs2(InputGroup2, { children: [
    /* @__PURE__ */ jsx4(InputLeftElement2, { children: /* @__PURE__ */ jsx4(SearchIcon, {}) }),
    /* @__PURE__ */ jsx4(Input2, { onChange: handleToggleCloseButton, ref: input, ...props }),
    showCloseButton && /* @__PURE__ */ jsx4(InputRightElement2, { mr: closeButtonPosition, children: /* @__PURE__ */ jsx4(CloseButton2, { onClick: handleClearSearch }) }),
    inputRightAddon && /* @__PURE__ */ jsx4(Box3, { as: "span", ml: 4, ref: addon, children: inputRightAddon })
  ] });
};
var SearchInput_default = SearchInput;

// src/components/data-display/Chip/components/ChipLabel.tsx
import { TagLabel as TagLabel2 } from "@chakra-ui/react";
import { jsx as jsx5 } from "react/jsx-runtime";
var ChipLabel = (props) => /* @__PURE__ */ jsx5(TagLabel2, { ...props });
var ChipLabel_default = ChipLabel;

// src/components/layout/Pages/PageContent.tsx
import { Container as Container2 } from "@chakra-ui/react";
import { jsx as jsx6 } from "react/jsx-runtime";
var PageContent = ({ children, className = "" }) => /* @__PURE__ */ jsx6(Container2, { py: 4, px: 8, maxWidth: "6xl", className, children });
var PageContent_default = PageContent;
export {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  AspectRatio,
  Badge,
  Box,
  Breadcrumb_default as Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Button,
  ButtonGroup,
  Center,
  ChakraProvider,
  Checkbox,
  CheckboxGroup_default as CheckboxGroup,
  Chip_default as Chip,
  ChipLabel_default as ChipLabel,
  TagLeftIcon as ChipLeftIcon,
  TagRightIcon as ChipRightIcon,
  CircularProgress,
  CircularProgressLabel,
  CloseButton,
  Code,
  Collapse,
  ColorModeProvider,
  ColorModeScript,
  Container,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DropdownItem_default as DropdownItem,
  Flex,
  FlyoutDropdown_default as FlyoutDropdown,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Grid,
  GridItem,
  HStack,
  Heading,
  Icon,
  IconButton_default as IconButton,
  InView,
  Input,
  InputGroup,
  InputLeftAddon,
  InputLeftElement,
  InputRightAddon,
  InputRightElement,
  Link,
  List,
  ListIcon,
  ListItem,
  Loader_default as Loader,
  Menu,
  MenuButton,
  MenuDivider,
  MenuGroup,
  MenuItem,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  Modal_default as Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NestedCheckbox_default as NestedCheckbox,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  OrderedList_default as OrderedList,
  PageContent_default as PageContent,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  PreloadAssets_default as Preload,
  Progress,
  Radio,
  RadioGroup,
  SearchInput_default as SearchInput,
  Select,
  SimpleGrid,
  Skeleton_default as Skeleton,
  SkeletonCircle,
  SkeletonText,
  Slide,
  Slider,
  SliderFilledTrack,
  SliderThumb,
  SliderTrack,
  Spacer,
  Stack,
  StackDivider,
  Stat_default as Stat,
  StatGroup,
  StatHelpText,
  StatLabel,
  StatNumber,
  StockXGoldTheme_default as StockXGoldTheme,
  Switch,
  SxInput_default as SxInput,
  SxSelect_default as SxSelect,
  SxTextarea_default as SxTextarea,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableCaption,
  Tabs,
  Tag,
  TagCloseButton,
  TagLabel,
  TagLeftIcon,
  TagRightIcon,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tooltip,
  Tr,
  UnorderedList_default as UnorderedList,
  VStack,
  VisuallyHidden,
  chakra,
  colors_default as colors,
  cookieStorageManager,
  extendTheme,
  theme_default as globalTheme,
  localStorageManager,
  shouldForwardProp,
  useBreakpoint,
  useCheckboxGroup,
  useClipboard,
  useColorMode,
  useColorModeValue,
  useConstructor_default as useConstructor,
  useDidUpdateEffect_default as useDidUpdateEffect,
  useDisclosure,
  useDrawer_default as useDrawer,
  useDropdown_default as useDropdown,
  useInView,
  useMediaQuery,
  useModal_default as useModal,
  useMultiStyleConfig,
  useOutsideClick,
  usePopover_default as usePopover,
  useRadio,
  useRadioGroup,
  useStyleConfig,
  useTheme,
  useToast_default as useToast,
  withDefaultColorScheme
};
